<mat-form-field appearance="outline">
  <mat-label>{{ 'sem_table.find' | translate }}</mat-label>
  <input [(ngModel)]="action.value.from" matInput name="from" placeholder="{{ 'sem_table.find' | translate }}" required />
</mat-form-field>

<mat-form-field appearance="outline">
  <mat-label>{{ 'sem_table.replace' | translate }}</mat-label>
  <input [(ngModel)]="action.value.to" matInput name="to" placeholder="{{ 'sem_table.replace' | translate }}" />
</mat-form-field>
